import "core-js/modules/es.array.push.js";
import request from "@/util/request";
import moment from "moment";
export default {
  name: "DeviceStatus",
  data() {
    return {
      ip: localStorage.getItem("ip"),
      urls: [],
      items: [{
        content: '',
        person: '',
        time: '',
        // color:'blue',
        beizhu: ''
      }],
      items2: [{
        content: '',
        person: '',
        time: '',
        // color:'blue',
        beizhu: ''
      }, {
        content: '',
        person: '',
        time: '',
        // color:'green',
        beizhu: ''
      }],
      items3: [{
        content: '',
        person: '',
        time: '',
        // color:'blue',
        beizhu: ''
      }, {
        content: '',
        person: '',
        time: '',
        // color:'green',
        beizhu: ''
      }, {
        content: '',
        person: '',
        time: '',
        // color:'green',
        beizhu: ''
      }],
      // select:null,
      form: {},
      options: [],
      //评分方案的类型列表
      option: {},
      //评分方案的类型对象
      formResult: {
        recStatus: 0
      },
      //驳回表单
      dialogFormVisible: false,
      dialogResultVisible: false,
      //不合格dialog控制
      tp: false,
      //检测图片dialog控制
      timeline: false,
      timeline2: false,
      timeline3: false,
      currentPage: 1,
      pageSize: 20,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [],
      //未分页的数据
      tableData: [],
      //渲染到页面上的数据

      disabledAudit: false,
      disabledQualified: false,
      theOne: {},
      //查看的单条数据
      RecordFlag: this.$route.query.RecordFlag,
      cxtj: false,
      //表单收集的数据
      ThisForm: {
        f1_startTimeOutweigh: this.formatDate(this.getbeforetime(), "yyyy-MM-dd hh:mm:ss"),
        f2_startTimeLessthen: this.formatDate(this.getaftertime(), "yyyy-MM-dd hh:mm:ss")
        // new_shsj: this.formatDate(this.shtime(), "yyyy-MM-dd"),
        // new_pzsj: this.formatDate(this.shtime(), "yyyy-MM-dd"),
      },

      //多选框
      formchecked: {
        checked1: true,
        checked2: true,
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        checked7: false,
        checked8: false,
        checked9: false,
        checked10: false,
        checked11: false,
        checked12: false,
        checked13: false
      },
      sh_form: {},
      pz_form: {},
      checkedA: true,
      checkedB: true,
      ticketPush: {},
      //图片路径
      imgUrl: require('/src/assets/logo.png'),
      authList: [],
      //用户的权限
      fileList: [{}]
    };
  },
  created() {
    this.load();
    // this.getList();
  },

  methods: {
    //刷新页面
    flushPage() {
      // this.load();
      this.$nextTick(() => {
        // this.$refs.table.doLayout()
        console.log("刷新成功");
        location.reload();
        // this.$router.push({path:'record', query:{RecordFlag : 5}})
      });
    },

    // 获取时间
    getbeforetime() {
      //获取到的时间 (中国标准时间)
      var d = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      // 处理成的格式
      var time = d.getFullYear() - 1 + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' 00:00:01';
      return new Date(time);
    },
    getaftertime() {
      var d = new Date();
      var time = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' 23:59:59';
      return new Date(time);
    },
    //页面初始化
    load() {
      let name = sessionStorage.getItem("userName");
      if (name == null || name == "" || name == undefined) {
        this.$message({
          type: 'warning',
          message: '登录超时请重新登录!'
        });
        this.$router.push({
          path: '/login',
          query: {}
        });
        return;
      }
      request.post('/RecDetView/queryDeviceStatus').then(res => {
        console.log(res);
        console.log(this.ticket);
        this.ticket = res;
        this.total = this.ticket.length;
        this.loadang = false;
        this.getPageInfo();
      });
    },
    // 表格查询
    //提交数据到后台
    submitForm(formchecked, ThisForm) {
      console.log(formchecked, ThisForm);
      console.log(this.ThisForm);
      console.log(this.mergeSQL());
      if (!this.formchecked.checked1 && !this.formchecked.checked2 && !this.formchecked.checked6 && !this.formchecked.checked7 && !this.formchecked.checked8 && !this.formchecked.checked9 && !this.formchecked.checked3 && !this.formchecked.checked4 && !this.formchecked.checked5 && !this.formchecked.checked10 && !this.formchecked.checked11 && !this.formchecked.checked12 && !this.formchecked.checked13) {
        this.tableData = [];
        this.total = 0;
        // this.loadang = false
        this.cxtj = false;
        console.log("没勾选值");
        this.$message({
          type: 'error',
          message: '请勾选要查询的内容!'
        });
      } else if (this.formchecked.checked1 || this.formchecked.checked2 || this.formchecked.checked6 || this.formchecked.checked7 || this.formchecked.checked8 || this.formchecked.checked9 || this.formchecked.checked3 || this.formchecked.checked4 || this.formchecked.checked5 || this.formchecked.checked10 || this.formchecked.checked11 || this.formchecked.checked12 || this.formchecked.checked13) {
        request.post("/RecDetView/combSelect4", {
          "sql": this.mergeSQL(),
          "RecordFlag": this.RecordFlag,
          userName: sessionStorage.getItem("userName"),
          roleId: sessionStorage.getItem("roleId"),
          areaId: sessionStorage.getItem("areaId")
        }).then(res => {
          console.log(res);
          this.ticket = [];
          this.cxtj = false;
          console.log(this.ticket);
          this.ticket = res;
          this.total = this.ticket.length;
          this.cxtj = false;
          this.getPageInfo();
        });
        if (this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh == '' || this.formchecked.checked8 && this.ThisForm.orderId == undefined || this.ThisForm.orderId == '' || this.formchecked.checked6 && this.ThisForm.areaName == undefined || this.formchecked.checked6 && this.ThisForm.areaName == '' || this.formchecked.checked7 && this.ThisForm.userAlias == undefined || this.formchecked.checked7 && this.ThisForm.userAlias == '' || this.formchecked.checked9 && this.ThisForm.liftId == undefined || this.formchecked.checked9 && this.ThisForm.liftId == '' || this.formchecked.checked3 && this.ThisForm.unit == undefined || this.formchecked.checked3 && this.ThisForm.unit == '' || this.formchecked.checked4 && this.ThisForm.liftNum == undefined || this.formchecked.checked4 && this.ThisForm.liftNum == '' || this.formchecked.checked5 && this.ThisForm.loginNum == undefined || this.formchecked.checked5 && this.ThisForm.loginNum == '' || this.formchecked.checked10 && this.ThisForm.lifeRegistCode == undefined || this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '' || this.formchecked.checked11 && this.ThisForm.unitCode == undefined || this.formchecked.checked11 && this.ThisForm.unitCode == '' || this.formchecked.checked12 && this.ThisForm.superviseCode == undefined || this.formchecked.checked12 && this.ThisForm.superviseCode == '' || this.formchecked.checked13 && (this.ThisForm.recStatus == '' || this.ThisForm.recStatus == undefined)) {
          this.tableData = [];
          this.cxtj = false;
          this.$message({
            type: 'error',
            message: '请输入要查询的内容!'
          });
        }
      }
    },
    showQuery() {
      this.cxtj = true;
    },
    //拼接sql
    mergeSQL() {
      var SQL = '';
      var SQL1 = " and recDate >= ",
        SQL2 = " and recDate <= ",
        SQL3 = " and unit like ",
        SQL4 = " and liftNum like ",
        SQL5 = " and loginNum like ",
        SQL6 = " and areaName like ",
        SQL7 = " and userAlias like ",
        SQL8 = " and orderId = ",
        SQL9 = " and liftId = ",
        SQL10 = " and lifeRegistCode like ",
        SQL11 = " and unitCode like ",
        SQL12 = " and superviseCode like ",
        SQL13 = " and recStatus = ";
      if (this.formchecked.checked1 && this.ThisForm.f1_startTimeOutweigh !== '' && this.ThisForm.f1_startTimeOutweigh !== undefined) {
        // eslint-disable-next-line no-useless-escape
        SQL1 += "'" + moment(this.ThisForm.f1_startTimeOutweigh).format('YYYY-MM-DD HH:mm:ss') + "'";
      } else {
        SQL1 = '';
      }
      if (this.formchecked.checked2 && this.ThisForm.f2_startTimeLessthen !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL2 += "'" + moment(this.ThisForm.f2_startTimeLessthen).format('YYYY-MM-DD HH:mm:ss') + "'";
        //console.log(SQL2)
      } else {
        SQL2 = '';
      }
      if (this.formchecked.checked3 && this.ThisForm.unit !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL3 += "'" + "%" + this.ThisForm.unit + "%" + "'";
        //console.log(SQL2)
      } else if (this.formchecked.checked3 && this.ThisForm.unit == '') {
        SQL3 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL3 = '';
      }
      if (this.formchecked.checked4 && this.ThisForm.liftNum !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL4 += "'" + "%" + this.ThisForm.liftNum + "%" + "'";
        //console.log(SQL2)
      } else if (this.formchecked.checked4 && this.ThisForm.liftNum == '') {
        SQL4 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL4 = '';
      }
      if (this.formchecked.checked5 && this.ThisForm.loginNum !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL5 += "'" + "%" + this.ThisForm.loginNum + "%" + "'";
        //console.log(SQL2)
      } else if (this.formchecked.checked5 && this.ThisForm.loginNum == '') {
        SQL5 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL5 = '';
      }
      if (this.formchecked.checked6 && this.ThisForm.areaName !== '') {
        SQL6 += "'" + "%" + this.ThisForm.areaName + "%" + "'";
      } else if (this.formchecked.checked6 && this.ThisForm.areaName == '') {
        SQL6 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL6 = '';
      }
      if (this.formchecked.checked7 && this.ThisForm.userAlias !== '') {
        SQL7 += "'" + "%" + this.ThisForm.userAlias + "%" + "'";
      } else if (this.formchecked.checked7 && this.ThisForm.userAlias == '') {
        SQL7 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL7 = '';
      }
      if (this.formchecked.checked8 && this.ThisForm.orderId !== '') {
        SQL8 += this.ThisForm.orderId;
      } else {
        SQL8 = '';
      }
      if (this.formchecked.checked9 && this.ThisForm.liftId !== '') {
        SQL9 += this.ThisForm.liftId;
      } else {
        SQL9 = '';
      }
      if (this.formchecked.checked10 && this.ThisForm.lifeRegistCode !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL10 += "'" + "%" + this.ThisForm.lifeRegistCode + "%" + "'";
        //console.log(SQL2)
      } else if (this.formchecked.checked10 && this.ThisForm.lifeRegistCode == '') {
        SQL10 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL10 = '';
      }
      if (this.formchecked.checked11 && this.ThisForm.unitCode !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL11 += "'" + "%" + this.ThisForm.unitCode + "%" + "'";
        //console.log(SQL2)
      } else if (this.formchecked.checked11 && this.ThisForm.unitCode == '') {
        SQL11 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL11 = '';
      }
      if (this.formchecked.checked12 && this.ThisForm.superviseCode !== '') {
        // eslint-disable-next-line no-useless-escape
        SQL12 += "'" + "%" + this.ThisForm.superviseCode + "%" + "'";
        //console.log(SQL2)
      } else if (this.formchecked.checked12 && this.ThisForm.superviseCode == '') {
        SQL12 += "'" + "%" + undefined + "%" + "'";
      } else {
        SQL12 = '';
      }
      if (this.formchecked.checked13 && this.ThisForm.recStatus !== '') {
        SQL13 += this.ThisForm.recStatus;
      } else {
        SQL13 = '';
      }
      SQL += SQL1 + SQL2 + SQL3 + SQL4 + SQL5 + SQL6 + SQL7 + SQL8 + SQL9 + SQL10 + SQL11 + SQL12 + SQL13;
      return SQL + '      order by updateDate desc';
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo();
    },
    tableRowClassName({
      rowIndex
    }) {
      // console.log(row)
      // console.log(rowIndex)
      if (rowIndex === 1) {
        // console.log(row)
        // console.log(rowIndex)
        return 'warning-row';
      } else if (rowIndex === 3) {
        // console.log(row)
        // console.log(rowIndex)
        return 'success-row';
      }
      return '';
    }
  }
};